import React from "react";
import { Link as RouterLink, NavLink as RouterNavLink } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";

// Drop-in replacement for react-router's <Link> that auto-prefixes the current language
export const Link = React.forwardRef(({ to, ...props }, ref) => {
  const { localizePath } = useLanguage();
  let finalTo = to;
  if (typeof to === "string") {
    finalTo = localizePath(to);
  } else if (to && typeof to === "object" && typeof to.pathname === "string") {
    finalTo = { ...to, pathname: localizePath(to.pathname) };
  }
  return <RouterLink ref={ref} to={finalTo} {...props} />;
});

export const NavLink = React.forwardRef(({ to, ...props }, ref) => {
  const { localizePath } = useLanguage();
  const finalTo = typeof to === "string" ? localizePath(to) : to;
  return <RouterNavLink ref={ref} to={finalTo} {...props} />;
});

// Hook for programmatic navigation
export { useNavigate, useParams, useLocation, useSearchParams, Outlet } from "react-router-dom";
